import {
  AdvanceTargetingQualification,
  Qualification,
} from '../../shared/interfaces/qualification.interface';

interface QualificationUpdate {
  update(code: number, update: unknown): unknown;
}

class SurveyNormalQualificationUpdater implements QualificationUpdate {
  constructor(private readonly _qualification: Qualification) {}

  public update(code: number, update: Partial<Qualification>): Qualification {
    if (Number(code) === Number(this._qualification.db_qualification_code)) {
      return {
        ...this._qualification,
        ...update,
      };
    }

    return this._qualification;
  }
}

class SurveyAdvancedQualificationUpdater implements QualificationUpdate {
  constructor(private readonly _qualification: AdvanceTargetingQualification) {}

  public update(
    code: number,
    update: Partial<AdvanceTargetingQualification>
  ): AdvanceTargetingQualification {
    if (Number(code) === Number(this._qualification.qualification_code)) {
      return {
        ...this._qualification,
        ...update,
      };
    }
    return this._qualification;
  }
}

export class SurveyQualificationUpdater {
  constructor() {}

  public normal(qualification: Qualification): QualificationUpdate {
    return new SurveyNormalQualificationUpdater(qualification);
  }

  public advanced(
    qualification: AdvanceTargetingQualification
  ): QualificationUpdate {
    return new SurveyAdvancedQualificationUpdater(qualification);
  }
}
